import React from 'react';

import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import Form1 from './forms/Form1';
import Form2 from './forms/Form2';
import Form3 from './forms/Form3';
import Form4 from './forms/Form4';
import Form5 from './forms/Form5';
import Form6 from './forms/Form6';

const Quoter = () => {
  return (
    <Router>
      <Switch>
        <Route path="*/cotizador-1">
          <Form1 />
        </Route>
        <Route path="*/cotizador-2">
          <Form2 />
        </Route>
        <Route path="*/cotizador-3">
          <Form3 />
        </Route>
        <Route path="*/cotizador-4">
          <Form4 />
        </Route>
        <Route path="*/cotizador-5">
          <Form5 />
        </Route>
        <Route path="*/cotizador-6">
          <Form6 />
        </Route>
        <Route render={() => <Redirect to="cotizador-1" />} />
      </Switch>
    </Router>
  );
};

export default Quoter;
